import { render, staticRenderFns } from "./modal-reset-payment.vue?vue&type=template&id=75ddb2f6"
import script from "./modal-reset-payment.vue?vue&type=script&lang=js"
export * from "./modal-reset-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports